import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import Breadcrumbs from '@mui/material/Breadcrumbs'
import { Link as RouterLink } from 'react-router-dom'
import MuiLink from '@mui/material/Link'
import './BreadCrumbStyle.css'
import RoutesConfig from '../../config/router/RoutesConfig'
import { matchPath } from 'react-router'
import { useSelector } from 'react-redux'
import { useBreadCrumbContext } from './BreadCrumbContext'
import { Grid } from '@mui/material'

const BreadCrumb = ({ isDesktop = true }) => {
  const [links, setLinks] = useState(null)
  const { t } = useTranslation()
  const location = useLocation()
  const roles = useSelector(({ login }) => login.roles)
  const { component, lastBreadLabel, setComponent } = useBreadCrumbContext()
  useEffect(() => {
    setComponent(null)
    items()
  }, [lastBreadLabel, location])

  const Item = ({ label, link, disableLink = false }) => (
    <MuiLink
      component={RouterLink}
      style={{ textDecoration: 'none' }}
      key={link}
      sx={{ display: 'flex', alignItems: 'center' }}
      to={link}
      onClick={(event) => {
        if (disableLink) {
          event.preventDefault()
        }
      }}
      variant="breadcrumb">
      {t(label)}
    </MuiLink>
  )

  const items = () => {
    const list = RoutesConfig.filter((route) => route?.permission?.includes(roles[0]))
      .filter((r) => {
        const match = matchPath(location.pathname, {
          path: Array.isArray(r.path) ? r.path[0] : r.path,
          exact: true,
          strict: false,
        })
        return match !== null ? true : false
      })
      .map((r) => r.breadCrumb)[0]
    if (list !== null && list !== undefined) {
      setLinks(
        list
          .filter((l) => !l.roles || l.roles?.includes(roles[0]))
          .map((e, i, row) => {
            let link = e.link
            let label = e.label
            let disableLink = false
            if (e.link.includes(':id')) {
              link = location.pathname
            }
            if (i + 1 === row.length) {
              disableLink = true
              if (lastBreadLabel !== undefined) {
                label = lastBreadLabel
              }
            }
            return <Item icon={e.icon} label={label} link={link} key={i} disableLink={disableLink} />
          }),
      )
    } else {
      setLinks('')
    }
  }

  return (
    <>
      {isDesktop && (
        <Grid container>
          <Grid size="grow">
            <Breadcrumbs fontSize="small" aria-label="breadcrumb" separator={''}>
              {links}
            </Breadcrumbs>
          </Grid>

          {component && component}
        </Grid>
      )}
    </>
  )
}

export default BreadCrumb
